import { useSlotEntries } from './addonRegistry'
import AddonErrorBoundary from './AddonErrorBoundary'

// A named place in core where add-ons may draw something: dashboard.widget, project.tab, nav.item.
// Shows an add-on's component only when the signed-in person has it switched on, and nothing at
// all (not even an empty wrapper) when there is none. Extra props go to each component.
export default function Slot({ name, className, ...props }) {
  const entries = useSlotEntries(name).filter((e) => e.component)
  if (!entries.length) return null
  const items = entries.map((e) => (
    <AddonErrorBoundary key={`${e.addon}:${e.id}`} addon={e.addon}>
      <e.component {...props} />
    </AddonErrorBoundary>
  ))
  return className ? <div className={className}>{items}</div> : <>{items}</>
}
